@if (adminLegacyForm) {
  <div class="dialog-root">
    <h2 mat-dialog-title>{{ "login.migrate_admin.title" | transloco }}</h2>

    <mat-dialog-content class="column" [formGroup]="adminLegacyForm">
      <p>
        {{"login.migrate_admin.info" | transloco}}
      </p>

      <mat-form-field hideRequiredMarker="true">
        <mat-label>{{ "login.migrate_admin.label.calit_customer_key" | transloco }}</mat-label>
        <input formControlName="customerKey" matInput type="text" />
      </mat-form-field>

      <mat-form-field hideRequiredMarker="true">
        <mat-label>{{"login.migrate_admin.label.calit_password" | transloco}}</mat-label>
        <input formControlName="password" matInput type="text" />
      </mat-form-field>

      <mat-form-field hideRequiredMarker="true">
        <mat-label>{{ "form.label.first_name" | transloco  }}</mat-label>
        <input formControlName="firstName" matInput type="text" />
      </mat-form-field>

      <mat-form-field hideRequiredMarker="true">
        <mat-label>{{"form.label.last_name" | transloco}}</mat-label>
        <input formControlName="lastName" matInput type="text" />
      </mat-form-field>

      <mat-form-field hideRequiredMarker="true">
        <mat-label>{{ "form.label.email"| transloco}}</mat-label>
        <input formControlName="email" matInput type="text" />
      </mat-form-field>

      @if (error) {
        <mat-error>{{ error }}</mat-error>
      }
    </mat-dialog-content>

    <mat-dialog-actions>
      <button (click)="close()" mat-button type="button">{{ "button.cancel" | transloco }}</button>
      <button (click)="add()" mat-flat-button type="submit">{{ "login.migrate_admin.button" | transloco }}</button>
    </mat-dialog-actions>
  </div>
}

